function DefaultAvatar() {
  return (
    <img
      src={
        "https://thumbs.dreamstime.com/b/default-avatar-profile-icon-social-media-user-vector-image-icon-default-avatar-profile-icon-social-media-user-vector-image-209162840.jpg"
      }
    />
  );
}

export default DefaultAvatar;
